import React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const ServiceTruckIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props} viewBox="0 0 48 48">
    <title>Service Truck</title>
    <path d="M44 29H43L40 13H32V9H4V33H9.1C9.03605 33.3296 9.00258 33.6643 9 34C9 36.7614 11.2386 39 14 39C16.7614 39 19 36.7614 19 34C18.9974 33.6643 18.9639 33.3296 18.9 33H30.1C30.0361 33.3296 30.0026 33.6643 30 34C30 36.7614 32.2386 39 35 39C37.7614 39 40 36.7614 40 34C39.9974 33.6643 39.964 33.3296 39.9 33H44V29ZM28 29H8V23.08H16L18.93 26H22.27L23.93 24.33L23.52 23.08H20.18V18.92H23.52L23.93 17.67L22.27 16H18.93L16 18.92H8V13H28V29ZM36.75 17L37.88 23H32V17H36.75Z"/>
  </IconBase>
);